import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=417411ed&scoped=true&"
import script from "./problem.vue?vue&type=script&lang=js&"
export * from "./problem.vue?vue&type=script&lang=js&"
import style0 from "./problem.vue?vue&type=style&index=0&id=417411ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417411ed",
  null
  
)

component.options.__file = "problem.vue"
export default component.exports